import React, { Component } from 'react';
import loaderImg from '../../static/images/rabbit-loading.gif';

export default class Loader extends Component {
  render() {
    let {T} = this.props
    return (
      <div>
        <img src={loaderImg} className="loading-image" alt="rabbit-loading"/>
        <h1>
            <T.text text={"processing.title-one"}/>
            <T.text text={"processing.title-two"}/>
        </h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/loader.js